<template>
    <div
        class="mt-4"
        :class="{'error-state': errorState}">
        <p class="lab c6 mb-0">
            {{heading}}
        </p>
        <b-dropdown
                :id="id"
                :text="text"
                class="cp-dropdown w-100 p1n"
                :class="`height-${maxHeight}`"
            >
            <b-dropdown-item
                    v-for="(item,index) in items"
                    :key="`${keyPlaceholder}-${index}`"
                    @click="$emit('setItem', item, campaign && campaign.id)"
                    class="p1n">
                {{item.date ? $options.filters.dateFromSeconds(item.date.seconds) : item.title}}
            </b-dropdown-item>
        </b-dropdown>
        <Icon 
            v-if="errorState"
            class="warning-icon-cp-modal"
            icon = "warning"
            class-name="warning-icon position-absolute"/>
    </div>
</template>


<script>
import moment from "moment";
import Icon from '../../Theme/Icon'

export default {
    name: 'Dropdown',
    components: {
        Icon
    },
    props: {
        items: Array,
        errorState: Boolean,
        heading: String,
        text: String,
        keyPlaceholder: String,
        campaign: Object,
        maxHeight: Number,
        id: String
    },
    filters: {
        dateFromSeconds: (seconds) => moment.utc(
            moment.unix(seconds)
        ).format('DD/MM/YYYY')
    }
}
</script>

<style lang="scss">
    .cp-dropdown {
        &.height-280 {
            ul {
                max-height:290px
            }
        }
        &.height-150 {
            ul {
                max-height:150px
            }
        }
        ul {
            overflow-y: auto;
            width: 101%;
            margin-left: -1px;
        }
        ul li a {
            text-overflow: ellipsis;
            white-space: nowrap;
            width: 195px;
            overflow: hidden;
            flex: 1;
        }
        button {
            width: 100% !important;
            height: 32px;
            border: 1px solid #C7C4C4!important;
            border-radius: 5px;
            background: #FFFFFF!important;
            color: #333333!important;
            font-size: 13px;
            text-align: left;
            padding-left: 7px !important;
            flex: 1;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;

            &:focus {
                box-shadow: none !important;
                border: 1px solid #C7C4C4!important;
            }

            &::after {
                position: absolute;
                left: 100%;
                top: 50%;
                transform: translate(-17px, 0);
            }
        }
    }
</style>